// extracted by mini-css-extract-plugin
export default {"invalidDataError":"addUserStyle_invalidDataError__rThke"};